export default __webpack_public_path__ + "static/mock-reward-1-32806c14299b1ddeca1073dd6311bb28.webp";